import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function syncCenterCosts(id: number) {
  return restApiClient.url(constructApiUrl(API.centers.syncCenterCosts.url, { id })).post()
}
